import { createFileRoute, Outlet } from "@tanstack/react-router";
import { requireModuleAccess, MODULE_WORKSPACE } from "../../../lib/auth/route-protection";

export const Route = createFileRoute("/workspace/users/$userId")({
  beforeLoad: requireModuleAccess(MODULE_WORKSPACE),
  component: () => <Outlet />,
});
